// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1O_Ya","row":"Node_row__3xTdS","label":"Node_label__3k2_R","footer":"Node_footer__2C5qe"};